import styled from 'styled-components';

import type { TitledMessageProps } from './titledMessage.types';

export const TitledMessageWrapper = styled.div<{ $maxWidth: TitledMessageProps['maxWidth'] }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: '100%';
  max-width: ${({ $maxWidth }) => $maxWidth};
  ${({ theme: { font } }) => font.t2}
`;

export const Title = styled.div<{ $align: TitledMessageProps['titleAligned'] }>`
  color: ${({ theme }) => theme.color.ui2};
  ${({ theme }) => theme.font.t1};
  text-align: ${({ $align }) => $align};
`;
